'use client';

import * as React from 'react';

import { useRouter } from 'next/navigation';

import { useCurrentLocale } from '@/shared/modules/localization';
import { getRelativePathnameTo } from '@/shared/modules/navigation';

import { getUrlToOauthServiceApi } from '../../api';
import { getClientIdRequiredByOauthService, getRedirectUrlToOauthService } from '../utils/common';

type ActionType = 'sign-in' | 'sign-up';

export const useRedirectToOauthService = () => {
  const router = useRouter();
  const locale = useCurrentLocale();

  const redirectToOauthService = React.useCallback(
    (actionType: ActionType) => {
      const { pathname, search, href } = window.location;

      const redirectUrlToOauthService = getRedirectUrlToOauthService({
        oauthUrl: getUrlToOauthServiceApi().toString(),
        actionType,
        authParams: new URLSearchParams({
          lang: locale,
          autoRedirect: 'true',
          clientId: getClientIdRequiredByOauthService(),
          state: encodeURIComponent(`${pathname}${search}`),
          redirectUri: new URL(getRelativePathnameTo(locale).authSegment(), href).toString(),
        }),
      });

      router.push(redirectUrlToOauthService);
    },
    [router, locale],
  );

  return { redirectToOauthService };
};
